module.exports = __webpack_public_path__ + "img/6.7c5c6c22.png";